import { createAction } from 'redux-actions';
import { SubscriptionsTierContentType } from '../../types/subscriptionsSection';

export const setSelectedTierEntityId = createAction(
  'SUBSCRIPTIONS_SECTION/SET_SELECTED_TIER_ENTITYID',
  (payload: string | number) => payload
);

export const setSelectedTierContentType = createAction(
  'SUBSCRIPTIONS_SECTION/SET_SUBSCRIPTIONS_SECTION_TYPE',
  (payload: SubscriptionsTierContentType) => payload
);
